import styled from 'styled-components'
import { $userInfoBd } from '../../../../components/store/user'
import { useUnit } from 'effector-react'

import coin from '../../../../UI/icons/Coin.svg'
import add_card from '../icons/add_card.svg'
import change_card from '../icons/change_card.svg'
import { MAIN_COLORS } from '../../../../UI/consts/colors'
import { memo } from 'react'

const Wrapper = styled.div<{card: boolean}>`
    display: flex;
    flex-direction: column;
    height: 100%;
    background: ${MAIN_COLORS.gradient_purple_200};
    border-radius: 10px;
    //gap: 16px;
    justify-content: space-between;
    padding: 0 8px 8px 8px;

    button {
        display: flex;
        background: transparent;
        border: none;
        align-items: center;
        border-radius: 8px;
        img {
            height:16px;
            width: 16px;
        }
    }

    .card-button {
        display: flex;
        height:32px;
        position: relative;
        justify-content: space-between;
        border: 2px solid ${p => p.card ?  MAIN_COLORS.purple_500 : 'transparent'};
        width: 100%;
        padding: 8px;
        color: ${p => p.card ? MAIN_COLORS.purple_600 : MAIN_COLORS.yellow};

        ${p => !p.card && `
            &::before {
                content: "";
                position: absolute;
                inset: 0;
                padding: 2px;
                border-radius: inherit;
                background: ${MAIN_COLORS.gradient_yellow_pink};

                -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
                -webkit-mask-composite: xor;
                mask-composite: exclude;
                transition: opacity 0.2s;
            }
        `}
    }
`

//const Flex = styled.div`
    //display: inline-flex;
    //flex: 1;
    //justify-content: flex-start;
    //width: 100%;
    //justify-content: space-between;

    //button {
    //    height: 68px;
    //    background: ${MAIN_COLORS.gradient_pink_400};
    //    padding: 12px;
    //}
//`
const Column = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;

    .main-header {
        display: flex;
        align-items: center;
        gap: 7px;
        background: ${MAIN_COLORS.gradient_yellow_pink};
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
`
const Balance = ({activateBalanceModal}:{activateBalanceModal: () => void}) => {
    const user = useUnit($userInfoBd);
    const text = user?.bonus_account?.card_number || 'Добавить карту';
    const balance = (user?.bonus_account?.balance || 0) / 100;

  return (
    <Wrapper card={Boolean(user?.bonus_account)} onClick={activateBalanceModal}>
        <Column>
            <h1>Ваш баланс</h1>
            <h1 className='main-header' style={{fontSize:'48px', lineHeight: '50px'}}>
                {balance}
                <img
                    src={coin}
                    className='coin'
                    alt=''
                />
            </h1>
        </Column>
            {
            //<button>
            //    <img
            //        src={plus}
            //        alt=''
            //    />
            //</button>
            }
        <button className='card-button'>
            <h5>{text}</h5>
            <img
                src={text === 'Добавить карту' ? add_card : change_card}
                alt=''
            />
        </button>
    </Wrapper>
  )
}

export default memo(Balance)
